import { atom } from "jotai";

interface Finding {
    artifactID?: string;
    audioBegin?: string;
    audioEnd?: string;
    begin?: number | null;
    comment?: string;
    company?: string;
    created?: string;
    createdF?: string;
    deleted?: number;
    editor?: string;
    end?: number | null;
    findingID?: string;
    findingTypeID?: string;
    id?: string;
    interview?: object;
    interviewID?: string;
    interviewee?: string;
    isDraft?: number;
    joinery?: Array<object>;
    modified?: string;
    name?: string | null;
    owner?: string;
    photoURL?: string;
    quote?: string;
    rating?: { global?: object };
    user?: object;
    userID?: string;
    username?: string;
}


const INITIAL_FINDINGS_IN_ATOM_VALUE: Finding[] = [];


export const findingsAtom = atom<Finding[]>(INITIAL_FINDINGS_IN_ATOM_VALUE);


export const setFindingsAtom = (set: Function, value: Finding[]) => {
    set(findingsAtom, value);
};
